<template>
  <div>
    <div class="max_box" :style="'min-height:' + height + 'px;'">
      <div class="box_form">
        <div>
          <p style="color: #676767;margin-bottom: 5px;">订单号 :</p>
          <el-input style="width: 220px" v-model="form.orderId" placeholder="请输入贵司订单号/科坦订单号"
                    size="mini" clearable></el-input>
        </div>
        <div class="time_box">
          <div>
            <p style="color: #676767;margin-bottom: 5px;">账单批次 :</p>
            <el-input style="width: 220px" v-model="form.batchNumber" placeholder="账单批次号"
                      size="mini" clearable></el-input>
          </div>

          <div>
            <p style="color: #676767;margin-bottom: 12px;"></p>
            <el-date-picker v-model="form.checkDates" type="daterange" range-separator="-"
                            start-placeholder="结算时间" end-placeholder="结算时间"
                            value-format="yyyy-MM-dd" size="mini"
                            style="position: relative;top: 2px;width: 230px !important;">
            </el-date-picker>
          </div>
        </div>
        <div>
          <p style="color: #676767;margin-bottom: 15px;"></p>
          <b2b-button style="width: 60px;height: 28px;line-height: 28px;" @click="onSearch(true)">搜 索</b2b-button>
        </div>
      </div>

      <el-table :data="billList" @sort-change="sortChange"
                style="width: 100%; margin-top: 20px; font-size: 12px" v-loading="isLoading">
        <el-table-column label="账单批次" prop="batchNumber" width="185"></el-table-column>
        <el-table-column label="结算维度" prop="outerId" width="120">
          <template slot-scope="scope">
            {{ getSettlementType(scope.row.extension) }}
          </template>
        </el-table-column>
        <el-table-column label="结算周期" prop="hotelName" width="180">
          <template slot-scope="scope">
            {{ getCheckTime(scope.row.extension) }}
          </template>
        </el-table-column>
        <el-table-column label="账单金额" width="130">
          <template slot-scope="scope">
            {{ scope.row.actualPrice ? `${partnerInfo.settleCurrency && currencyMap[partnerInfo.settleCurrency ] ? currencyMap[partnerInfo.settleCurrency ] : '￥' }${(scope.row.actualPrice / 100).toFixed(2)}` : '' }}
          </template>
        </el-table-column>
        <el-table-column label="账单状态" prop="payAmount" width="100">
          <template slot-scope="scope">
            <div style="display: flex;align-items: center;column-gap: 5px">
              <div class="dot"></div>
              <span>已结算</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="结算时间" prop="createDate" width="145" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.createDate ? scope.row.createDate.replace('T', ' ') : '' }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div style="display: flex;align-items: center;column-gap: 8px">
              <p @click="showDetail(scope.row)" style="color:#1e50f0;cursor: pointer;">详情</p>
              <p @click="exportBill(scope.row)" style="color:#1e50f0;cursor: pointer;">导出</p>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination :current-page="form.pageCurrent" :page-size="form.pageSize"
                       layout="total, prev, pager, next, jumper" :total="form.total" :hide-on-single-page="true"
                       @current-change="pageChange" style="margin: auto;">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HotelBill',
  data () {
    return {
      partnerInfo: {},
      headers: {},
      height: 0,
      form: {
        pageSize: 20,
        pageCurrent: 1,
        total: 0
      },
      billList: [],
      isLoading: false,
      currencyMap: {
        'CNY': '￥',
        'USD': '$'
      }
    }
  },
  created () {
    this.partnerInfo = JSON.parse(this.$common.isLogin())
    this.headers = {accessToken: this.partnerInfo.token}
    if (!this.partnerInfo) {
      this.$message.warning('请登录后再查看')
      this.$router.push('/login')
    }
    this.height = this.$common.getScreenInfo().height - 90 - 40
    this.onSearch(true)
  },
  methods: {
    async onSearch (flag) {
      if (flag) {
        this.form.pageCurrent = 1
      }
      this.isLoading = true
      const {data: result} = await this.$http.post('/b2b/searchChlBatchBill', this.form, {headers: this.headers})
      this.isLoading = false
      if (result.code !== 200) return this.$message.error(result.message)
      this.billList = result.data.data
      this.form.total = result.data.total | 0
    },
    pageChange (e) {
      this.form.pageCurrent = e
      this.onSearch()
    },
    sortChange (e) {
      if (!e.order) {
        this.$delete(this.form, 'sortType')
      } else {
        let sortType = e.order === 'ascending' ? 1 : e.order === 'descending' ? 2 : null
        this.$set(this.form, 'sortType', sortType)
      }
      this.onSearch(true)
    },
    getSettlementType (extension) {
      let settlementType = this.getExtension(extension, 'settlementType')
      return settlementType === 1 ? '入住' : settlementType === 2 ? '离店' : settlementType === 3 ? '预订' : ''
    },
    getCheckTime (extension) {
      let time = this.getExtension(extension, 'time')
      return time && time.length ? `${time[0]} ~ ${time[1]}` : ''
    },
    getExtension (extension, key) {
      if (!extension) return ''
      try {
        let res = JSON.parse(extension)
        return res[key]
      } catch (e) {
        return ''
      }
    },
    async showDetail (row) {
      let req = {
        batchNumber: row.batchNumber,
        actualPrice: row.actualPrice ? row.actualPrice / 100 : '',
        createDate: row.createDate ? row.createDate.replace('T', ' ') : '',
        checkTime: this.getExtension(row.extension, 'time'),
        settlementType: this.getSettlementType(row.extension)
      }
      let url = `/hotelBillDetail?detail=${window.btoa(encodeURIComponent(JSON.stringify(req)))}`
      window.open(url, '_blank')
    },
    async exportBill (row) {
      let loading = this.$loading({
        text: '账单导出中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let req = {
        batchNumber: row.batchNumber
      }
      const result = await this.$http.post('/b2b/exportChlBatchBillDetail', req
        , {headers: this.headers, responseType: 'blob'})
      loading.close()
      if (!result.data) return this.$message.error('下载失败, 请稍后重试')
      let fileName = `${this.partnerInfo.companyName}${row.batchNumber}-${new Date().Format('yyyy-MM-dd HH:mm:ss')}.xlsx`
      const link = document.createElement('a')
      let blob = new Blob([result.data], {type: 'application/vnd.ms-excel;charset=utf-8'})
      link.style.display = 'none'
      link.href = URL.createObjectURL(blob)
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      this.$message.success('导出成功')
    }
  }
}
</script>

<style scoped lang="less">
.max_box {
  background-color: #fff;
  padding: 20px;
}

.box_form {
  padding: 20px;
  border: 1px solid #e7e7e7;
  background-color: #f7f7f7;
  margin-bottom: 15px;
  display: flex;
  flex-wrap: wrap;
  column-gap: 15px;
  row-gap: 15px;
  align-items: center;

  .time_box {
    display: grid;
    grid-template-columns: repeat(3, max-content);
    align-items: center;
    grid-column-gap: 10px;
  }

  & /deep/ .el-input .el-select {
    min-width: auto !important;
    width: auto !important;
  }
}

.pagination {
  margin: 35px;
  position: relative;

  /deep/ .el-pagination {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.dot {
  background-color: #70b603;
  border-radius: 100px;
  height: 4px;
  width: 4px;
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/order/HotelBill.vue